import { type AgnosticShipment } from './AgnosticShipment'

export type ShipmentListChatState = 'hidden' | 'no-chat' | 'read' | 'unread'

export function getShipmentListChatState(
  shipment: Pick<AgnosticShipment, 'bookedRateUuid' | 'chat' | 'shipmentURL'>
): ShipmentListChatState {
  if (!shipment.bookedRateUuid) return 'hidden'
  if (!getInviteTokenFromShipmentUrl(shipment.shipmentURL)) return 'hidden'
  if (!shipment.chat.hasChat) return 'no-chat'
  if (shipment.chat.unreadByCarrierCount > 0) return 'unread'
  return 'read'
}

export function formatUnreadChatTooltip(count: number): string {
  return count === 1 ? '1 unread message' : `${count} unread messages`
}

export function getShipmentListChatTooltip(
  state: ShipmentListChatState,
  unreadCount: number
): string {
  if (state === 'no-chat') return 'Click to create a chat with the shipper'
  if (state === 'unread') return formatUnreadChatTooltip(unreadCount)
  return 'No new messages'
}

export function getInviteTokenFromShipmentUrl(shipmentURL?: string): string | undefined {
  if (!shipmentURL) return undefined

  try {
    const url = new URL(shipmentURL)
    const hashQueryIndex = url.hash.indexOf('?')
    const tokenFromHash =
      hashQueryIndex >= 0
        ? new URLSearchParams(url.hash.slice(hashQueryIndex + 1)).get('token')
        : null
    const tokenFromSearch = url.searchParams.get('token')

    return tokenFromHash || tokenFromSearch || undefined
  } catch {
    return undefined
  }
}
